module.exports = __webpack_public_path__ + "img/Footway.d6a4abda.png";